import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';

export default () =>
  useApiQuery<{
    deviceTypes: { name: string; parentSourceDeviceNull: boolean }[];
  }>({
    queryKey: [QueryKeys.deviceTypes],
    apiPath: '/devices/types',
    method: 'GET',
    useV2API: true,
  });
